import { Controller } from '@hotwired/stimulus'

// Page-level language tabs for the landing editor. Shows only the active locale's
// fields (every field still renders all locales, so all three submit regardless
// of which tab is active).
export default class extends Controller<HTMLElement> {
  static targets = ['tab', 'field']
  static values = { active: { type: String, default: 'en' } }

  declare readonly tabTargets: HTMLElement[]
  declare readonly fieldTargets: HTMLElement[]
  declare activeValue: string

  connect(): void {
    this.update()
  }

  select(event: Event): void {
    this.activeValue = (event.currentTarget as HTMLElement).dataset.locale || 'en'
    this.update()
  }

  private update(): void {
    this.fieldTargets.forEach((field) => {
      field.hidden = field.dataset.locale !== this.activeValue
    })
    this.tabTargets.forEach((tab) => {
      const on = tab.dataset.locale === this.activeValue
      tab.setAttribute('aria-current', String(on))
      tab.style.background = on ? 'var(--color-primary)' : 'transparent'
      tab.style.color = on ? '#fff' : 'var(--color-muted)'
    })
  }
}
